import { type Html, html, rune, View } from 'rune-ts';
import klass from './BenefitSection.module.scss';
import { font } from '../../../../../shared/typography';
import { BenefitCard } from './BenefitCard';
import { map, pipe, toArray } from '@fxts/core';
import Swiper from 'swiper';
import { htmlIf } from '../../../../../shared/util';
import { Pagination } from 'swiper/modules';
import { media_url_info } from '../../constant';

export class BenefitSection extends View {
  swiper?: Swiper;
  constructor() {
    super({});
  }

  override template(): Html {
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;
    const texts = {
      title: is_mobile
        ? html.preventEscape('브랜드 협업, 마플샵과 <br /> 함께하면 이런 점이 달라요')
        : html.preventEscape('브랜드 협업, <br />마플샵과 함께하면 이런 점이 달라요'),
    };
    const card_props = [
      {
        image_url: media_url_info.benefit_section.image_1,
        title: '브랜드 맞춤 매칭 및 1:1 운영 케어',
        desc: html`
          <div class="${klass.desc_text}"><span>마플샵 담당 MD</span>가</div>
          <div class="${klass.desc_text}">내 채널과 구독자 특성에 맞는</div>
          <div class="${klass.desc_text}">
            <span>브랜드 매칭</span> 및
            <span>협상, 계약, 진행, CS</span>
          </div>
          <div class="${klass.desc_text}">전 과정을 섬세하게 케어해 드려요</div>
        `,
      },
      {
        image_url: media_url_info.benefit_section.image_2,
        title: '간편하고 투명한 정산',
        desc: html`
          <div class="${klass.desc_text}">마플샵 스튜디오에서</div>
          <div class="${klass.desc_text}"><span>실시간으로 판매량을 확인 </span>하고</div>
          <div class="${klass.desc_text}"><span>손쉽고 투명하게</span>정산할 수 있어요</div>
        `,
      },
      {
        image_url: media_url_info.benefit_section.image_3,
        title: '판매 수수료 면제',
        desc: html`
          <div class="${klass.desc_text}">마플샵 커머스 크리에이터에게는</div>
          <div class="${klass.desc_text}"><span>2025년 한해 판매 수수료를</span></div>
          <div class="${klass.desc_text}"><span>면제해 드려요</span></div>
        `,
      },
    ];

    return html`
      <section class="${klass.benefit} swiper">
        <div class="${klass.title} ${font('48_bold', '28_bold')}">${texts.title}</div>
        <div class="${klass.benefit_list} swiper-wrapper">
          ${pipe(
            card_props,
            map((prop) => new BenefitCard(prop)),
            toArray,
          )}
        </div>
        ${htmlIf(html`<div class="swiper-pagination ${klass.pagination}"></div>`, is_mobile)}
      </section>
    `;
  }

  override onRender() {
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;

    if (is_mobile) {
      this.swiper = this._onLoadSwiper();
    }
  }

  private _onLoadSwiper() {
    return new Swiper(`.${klass.benefit}`, this._createSwiperOption());
  }

  private _createSwiperOption() {
    return {
      modules: [Pagination],
      pagination: {
        el: '.swiper-pagination',
        type: 'progressbar',
        progressbarFillClass: `${klass.progressbar_fill} swiper-pagination-progressbar-fill`,
      } as const,
    };
  }
}
